export function csrfToken(): string | undefined {
  return document.cookie.split('; ').find((part) => part.startsWith('conductor_csrf='))?.split('=').slice(1).join('=');
}

export function apiFetch(input: RequestInfo | URL, init: RequestInit = {}): Promise<Response> {
  const method = (init.method ?? 'GET').toUpperCase();
  const headers = new Headers(init.headers);
  if (!['GET', 'HEAD', 'OPTIONS'].includes(method)) {
    const token = csrfToken();
    if (token) headers.set('X-CSRF-Token', decodeURIComponent(token));
  }
  return fetch(input, { ...init, headers, credentials: 'same-origin' });
}
